<template>
  <v-col cols="2" md="1" class="pa-0 next-chapter-sidebar text-center">

    <div class="bar" @click="onNextClick">
      <div class="content px-4 pt-1 pb-12">
        <ArrowIcon @click.stop="onPrevClick" class="arrow-icon d-block mx-auto arrow-icon--reverted" />
        <ArrowIcon class="arrow-icon d-block mb-5 mx-auto" />
        <span class="mt-2"><translate>Next chapter</translate></span>
      </div>
    </div>
  </v-col>
</template>

<script>
import ArrowIcon from '@/assets/svg/arrow.svg'

export default {
  name: 'NextPrevChapterSidebar',

  props: {
    bg: {
      type: String,
      required: false,
      default: ''
    }
  },

  components: {
    ArrowIcon
  },

  methods: {
    onNextClick () {
      this.$emit('next:click')
      // ...
    },

    onPrevClick () {
      this.$emit('prev:click')
      // ...
    }
  }
}
</script>

<style scoped lang="scss">

.next-chapter-sidebar {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 35%;
  z-index: 1;

  @include breakpoint('sm-and-up') {
    height: 50%;
  }

  @include breakpoint('md-and-up') {
    height: 70%;
  }
}

.bar {
  height: 100%;
  background-color: rgba($c-red, 0.5);
  // backdrop-filter: blur(4px);
  z-index: 2;
  cursor: pointer;
  transition: background-color 0.5s;

  &:hover {
    background-color: rgba($c-red, 0.9);
  }

  span {
    writing-mode: vertical-rl;
    text-orientation: mixed;
  }

  .bg-image {
    position: absolute;
    backdrop-filter: blur(4px);
    opacity: 0.4;
    transition: opacity 0.5s;
    height: 100%;
  }

  .content {
    position: relative;
  }
}

.arrow-icon {
  height: 15px;
  width: 15px;
  margin-top: 15px;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.4s;

  @include breakpoint('md-and-up') {
    margin-top: 20px;
    height: 25px;
    width: 25px;
  }

  &:hover {
    opacity: 1;
  }

  &--reverted {
    //margin-top: -60px;
    transform: rotate(-180deg);

    @include breakpoint('md-and-up') {
      //margin-top: -75px;
    }
  }
}

</style>
